import React from 'react';
import CheckCalendarContainer from '../../organisms/RTCC/checkCalendarContainer';
import HeaderContainer from '../../organisms/RTCC/headerContainer';
import ReservationPopupContainer from '../../organisms/RTCC/reservationPopupContainer';
import RtccBookingConfirmContainer from '../../organisms/RTCC/rtccBookingConfirmContainer';
import ScrollToTop from '../../atoms/RTCC/scrollToTop';

class RtccBookingConfirmTemplate extends React.Component {

    render() {
        return (
            <>
                <ScrollToTop />
                <HeaderContainer
                    Label categoryLabel1={"予約内容確認"}
                    categoryLabel2={"CONFIRM"}
                    path={"/reserve/rtcc/reservation"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                />
                <CheckCalendarContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    checkInFlg={this.props.state.checkInFlg}
                    checkOutFlg={this.props.state.checkOutFlg} />
                <RtccBookingConfirmContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                />
                <ReservationPopupContainer
                    key={"reservationPopup"}
                    state={this.props.state}
                    setPopupMode={this.props.setPopupMode}
                    setPopupMessage={this.props.setPopupMessage}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
            </>
        )
    }
}
export default RtccBookingConfirmTemplate;